// John Eldhose 20180511
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Divider, Grid, Snackbar, TextField, Typography } from '@material-ui/core';
import { Email } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import { recover } from '../Api/recover';

class Recover extends Component {

  state = {
    clicked: false,
    email: '',
    emailError: false,
    recoverColor: 'red',
    recoverHelper: '',
    recoverError: false
  }
  handleUserInput (event, lower = false) {
    this.setState({ [event.target.name]: (
      lower ? event.target.value.toLowerCase() : event.target.value
    ) });
    const error = event.target.name + 'Error';
    this.setState({ [error]: false });
  }
  handleChangeEmail = (event) => {
    this.setState({ email: event.target.value })
  }
  handleClickRecover = () => {
    this.setState({ clicked: true });
    recover(this.state.email)
      .then((recover) => {
        if(recover['status'] === 'true') {
          this.setState({
            recoverHelper: 'Password reset email is sent',
            recoverColor: 'white'
          });
          this.setState({ recoverError: true });
        }
        else {
          let fld = '';
          this.setState({ recoverHelper: recover['error'] });
          this.setState({ recoverError: true });
          if(recover['fields'].length > 0) {
            recover['fields'].map((field) => {
              fld = field + 'Error';
              this.setState({ [fld]: true });
              return false;
            })
          }
          this.setState({ clicked: false });
        }
      })
      .catch((error) => {
        this.setState({ recoverHelper: 'Failed to send password reset email' });
        this.setState({ recoverError: true });
        this.setState({ clicked: false });
      })
  }
  handleCloseRecovery = () => {
    this.setState({ recoverError: false });
  }

  render() {
    return (
      <div>
      <Typography variant='display1'>
        <font color='#385687'>Carlson Customer Login</font>
      </Typography>
        <Typography variant='title'>
          <font color='black'>
            <FormattedMessage
              id='Reset Carlson account password'
              defaultMessage='Reset Carlson account password'
            />
          </font>
        </Typography>
        <p />
        <Typography variant='subheading'>
          <FormattedMessage
            id='Shared between Carlson Cloud, Community, PhotoCapture, and Academy'
            defaultMessage='Shared between Carlson Cloud, Community, PhotoCapture, and Academy'
          />
        </Typography>
        <p />
        <div style={{ border: '1px solid silver' }}>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Email className='IconProp' />
            </Grid>
            <Grid item xs zeroMinWidth>
              <FormattedMessage
                id='Email address'
                defaultMessage='Email address'
              >
                {(msg) => (
                  <TextField
                    required
                    fullWidth
                    label={msg}
                    name='email'
                    value={this.state.email}
                    error={this.state.emailError}
                    onChange={(event) => this.handleUserInput(event, true)}
                  />
                )}
              </FormattedMessage>
            </Grid>
          </Grid>
        </div>
        <p />
        <Button
          variant='raised'
          color='primary'
          fullWidth
          onClick={this.handleClickRecover}
        >
          <FormattedMessage
            id='Send Password Reset Email'
            defaultMessage='Send Password Reset Email'
          /> &nbsp;
          <Email />
        </Button>
        <p />
        <Divider />
        <p />
        <Grid container>
          <Grid item xs={12} sm={12} md={12}>
            <Button component={Link} to='/' fullWidth>
              <FormattedMessage
                id='Return to Login'
                defaultMessage='Return to Login'
              />
            </Button>
          </Grid>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={this.state.recoverError}
          onClose={this.handleCloseRecovery}
          message={
            <span style={{ color: this.state.recoverColor }}>
              {this.state.recoverHelper}
            </span>
          }
        />
      </div>
    );
  }
}

export default Recover;



// WEBPACK FOOTER //
// ./src/components/Recover.js